import { PriceAvailabilityResponse } from 'services/priceAvailability/types';
import {
  getPartsDetails,
  itemsSummaryApiCall,
  partWhereUsedApiCall
} from 'services/parts-diagram/actions';
import {
  CATEGORY_TYPES,
  PartDetailsAndSchematicResponse,
  PartWhereUsed
} from 'types/parts-diagram';

export const getPrice = (
  partDetailsAndSchematicResponse: PartDetailsAndSchematicResponse,
  priceData: PriceAvailabilityResponse
) => {
  const partItems = partDetailsAndSchematicResponse.lineItems.map((item) => {
    return {
      ...item,
      quantity: item.quantity.trim().length === 0 ? '1' : item.quantity,
      partNumber: formatPartNumber(item.partNumber)
    };
  });

  const priceAndDetailsSchematic = partItems.map((lineItem) => {
    const priceAndAvailabilityData = priceData.items.find(
      (price) => price.partNumber === lineItem.partNumber
    );
    if (priceAndAvailabilityData) {
      return {
        ...lineItem,
        priceAndAvailabilityData: priceAndAvailabilityData
      };
    }
    return lineItem;
  });

  return {
    ...partDetailsAndSchematicResponse,
    currency: priceData.currency,
    lineItems: priceAndDetailsSchematic
  };
};

const formatPartNumber = (partNumber = '') => {
  if (partNumber) {
    return partNumber.includes('-')
      ? partNumber
      : `${partNumber.slice(0, -4)}-${partNumber.slice(-4)}`;
  }
  return partNumber;
};

export const getFormattedPartNumberOfLineItems = (lineItems = []) => {
  return lineItems.map((item) => {
    if (!item.partNumber) return { ...item };
    return {
      ...item,
      partNumber: formatPartNumber(item.partNumber)
    };
  });
};

export const getFormattedNameOfLineItems = async (lineItems = []) => {
  const allPartNumbers = lineItems
    .filter((item) => item.partNumber)
    .map((item) => item.partNumber);

  if (allPartNumbers.length > 0) {
    const itemsSummaryResponse: ISummary =
      await itemsSummaryApiCall(allPartNumbers);
    if (itemsSummaryResponse?.products?.length > 0) {
      return lineItems.map((item) => {
        const findItemSummary = itemsSummaryResponse.products.find(
          (itemSummary) => itemSummary.partNumber === item.partNumber
        );
        return {
          ...item,
          name: findItemSummary?.name || item.name
        };
      });
    }
  }

  return lineItems;
};

export const getHandleclickViewButton = async (
  partNumber,
  getHandleSelectedPart,
  getparams
) => {
  const { setParamsWithWindows, checkParamsHas, deleteParams } = getparams;
  const { handlePartsContentCategory, handleSelectedPart } =
    getHandleSelectedPart;

  handlePartsContentCategory(CATEGORY_TYPES.LOADER);
  const partWhereUsedResponse = (await partWhereUsedApiCall(
    partNumber
  )) as PartWhereUsed[];
  const { ieSystemControlNumber, systemId } = partWhereUsedResponse[0] || {};
  const { componentId } = partWhereUsedResponse[0].components[0] || {};
  function updateParams(systemId, componentId, ieSystemControlNumber) {
    ['componentId', 'ieSystemControlNumber'].forEach(
      (param) => checkParamsHas(param) && deleteParams(param)
    );

    setParamsWithWindows('systemId', systemId);
    setParamsWithWindows('componentId', componentId);
    setParamsWithWindows('ieSystemControlNumber', ieSystemControlNumber);
  }

  updateParams(systemId, componentId, ieSystemControlNumber);

  const { partDetailsAndSchematicResponse } = await getPartsDetails(
    ieSystemControlNumber
  );
  if (partDetailsAndSchematicResponse) {
    handlePartsContentCategory(
      CATEGORY_TYPES.PARTSDETAILS,
      null,
      partDetailsAndSchematicResponse
    );
    const pNumber = partNumber?.replace(/-/g, '');
    handleSelectedPart({ partNumber: pNumber, ieSystemControlNumber });
  }
};
